const setFocus = (element) => {
    if (!element)
        return;
    // To get this method working in Safari use a setTimeout
    setTimeout(() => {
        element && element.focus && element.focus();
    }, 0);
};

export { setFocus as s };
